// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11503-根据id删除banner POST /web/v1/banner/delete/${param0} */
export async function deleteSwimBanner(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteSwimBannerParams,
  options?: { [key: string]: any }
) {
  const { bannerId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/banner/delete/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11504-根据id禁用banner POST /web/v1/banner/disable/${param0} */
export async function disableSwimBanner(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.disableSwimBannerParams,
  options?: { [key: string]: any }
) {
  const { bannerId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/banner/disable/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11504-根据id启用banner POST /web/v1/banner/enable/${param0} */
export async function enableSwimBanner(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.enableSwimBannerParams,
  options?: { [key: string]: any }
) {
  const { bannerId: param0, ...queryParams } = params;
  return request<API.YmResultVOString>(`/web/v1/banner/enable/${param0}`, {
    method: "POST",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11501-分页查询banner POST /web/v1/banner/pageList */
export async function webGetSwimBannerPageList(
  body: API.SwimBannerPageQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimBannerBasicVo>(
    "/web/v1/banner/pageList",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 11502-更新banner POST /web/v1/banner/upsert */
export async function upsertSwimBanner(
  body: API.SwimBannerBasicVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOString>("/web/v1/banner/upsert", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
